/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.14.7.0 (NJsonSchema v10.5.2.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { getAuth0Token, getVectorBaseUrl, transformApiResult, transformRequestOptions } from './VectorClientHelpers';
export class VectorClientBase { 

    protected transformOptions(options: any) {
        return this.getToken().then(newToken => transformRequestOptions(newToken, options));
      }
  
  protected transformResult(url: string, response: Response, processor: (response: Response) => any) {
    return transformApiResult(url, response, processor);
  }

  protected getBaseUrl(urlTemplate: string, defaultUrl: string | undefined): string {
    return getVectorBaseUrl(urlTemplate, defaultUrl);
  }

  private async getToken() {
    return getAuth0Token();
  }
}

export interface IOtherClient {
    /**
     * @return Success
     */
    debug(): Promise<DebugResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    row(body?: PrimusDebugRequest | undefined): Promise<string>;
    /**
     * @param body (optional) 
     * @return Success
     */
    notify(body?: PrimusDebugRequest | undefined): Promise<boolean>;
    /**
     * @return Success
     */
    heartbeat(): Promise<HeartbeatResponse>;
    /**
     * @return Success
     */
    primus(): Promise<string>;
}

export class OtherClient extends VectorClientBase implements IOtherClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @return Success
     */
    debug(): Promise<DebugResponse> {
        let url_ = this.baseUrl + "/Debug";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDebug(_response));
        });
    }

    protected processDebug(response: Response): Promise<DebugResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DebugResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DebugResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    row(body?: PrimusDebugRequest | undefined): Promise<string> {
        let url_ = this.baseUrl + "/Debug/row";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRow(_response));
        });
    }

    protected processRow(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    notify(body?: PrimusDebugRequest | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/Debug/notify";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processNotify(_response));
        });
    }

    protected processNotify(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * @return Success
     */
    heartbeat(): Promise<HeartbeatResponse> {
        let url_ = this.baseUrl + "/Heartbeat";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processHeartbeat(_response));
        });
    }

    protected processHeartbeat(response: Response): Promise<HeartbeatResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HeartbeatResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HeartbeatResponse>(<any>null);
    }

    /**
     * @return Success
     */
    primus(): Promise<string> {
        let url_ = this.baseUrl + "/api/apps/Primus";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPrimus(_response));
        });
    }

    protected processPrimus(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(<any>null);
    }
}

export class DebugResponse implements IDebugResponse {
    status?: string | undefined;
    timestamp?: Date;
    primus?: PrimusDebugResponse;

    constructor(data?: IDebugResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.primus = data.primus && !(<any>data.primus).toJSON ? new PrimusDebugResponse(data.primus) : <PrimusDebugResponse>this.primus; 
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : <any>undefined;
            this.primus = _data["primus"] ? PrimusDebugResponse.fromJS(_data["primus"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DebugResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DebugResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        data["primus"] = this.primus ? this.primus.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IDebugResponse {
    status?: string | undefined;
    timestamp?: Date;
    primus?: IPrimusDebugResponse;
}

export class HeartbeatResponse implements IHeartbeatResponse {
    status?: string | undefined;
    timestamp?: Date;

    constructor(data?: IHeartbeatResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): HeartbeatResponse {
        data = typeof data === 'object' ? data : {};
        let result = new HeartbeatResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IHeartbeatResponse {
    status?: string | undefined;
    timestamp?: Date;
}

export class PrimusDebugRequest implements IPrimusDebugRequest {
    text?: string | undefined;

    constructor(data?: IPrimusDebugRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): PrimusDebugRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PrimusDebugRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text;
        return data; 
    }
}

export interface IPrimusDebugRequest {
    text?: string | undefined;
}

export class PrimusDebugResponse implements IPrimusDebugResponse {
    core?: boolean;
    sentinel?: boolean;
    comms?: boolean;

    constructor(data?: IPrimusDebugResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.core = _data["core"];
            this.sentinel = _data["sentinel"];
            this.comms = _data["comms"];
        }
    }

    static fromJS(data: any): PrimusDebugResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PrimusDebugResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["core"] = this.core;
        data["sentinel"] = this.sentinel;
        data["comms"] = this.comms;
        return data; 
    }
}

export interface IPrimusDebugResponse {
    core?: boolean;
    sentinel?: boolean;
    comms?: boolean;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    throw new ApiException(message, status, response, headers, result);
}